import type { PosAjustesDeLaFoto, PosLocalTerminal } from "@/platform/types";

/** El local de la caja de este equipo, para entrar a su mostrador. */
export interface LocalDeLaCaja {
  warehouseId: string;
  /** `null` si no hay de dónde sacarlo sin red. */
  nombre: string | null;
  /** El nombre de la caja (`Caja 1`). */
  caja: string;
}

/**
 * El local de la caja de este equipo (#346 AC-1): el equipo lo sabe sin red,
 * así que el mostrador se puede abrir aunque no se pueda traer la lista de
 * locales. Sólo si es una caja activa: la dada de baja no vende sin red. El
 * nombre sale de la lista de locales si está, o de la foto; si no, no se sabe.
 */
export function localDeLaCaja(
  terminal: PosLocalTerminal | null | undefined,
  {
    locales,
    foto,
  }: {
    locales?: { id: string; name: string }[] | null;
    foto?: PosAjustesDeLaFoto | null;
  }
): LocalDeLaCaja | null {
  if (!terminal?.terminalId || terminal.status !== "active") return null;
  const { warehouseId } = terminal;
  const nombre =
    locales?.find((l) => l.id === warehouseId)?.name ??
    foto?.warehouses?.find((w) => w.id === warehouseId)?.name ??
    foto?.ticket?.warehouseName ??
    null;
  return { warehouseId, nombre, caja: terminal.name };
}
